<template>
  <span>
    <aside
      class="categories-sidebar mb-4"
      v-if="categoriaSelecionada && subcategoriaSelecionada && filtrosList.length"
    >
      <h3 class="sidebar-title text-center mb-2">Filtros</h3>
      <div class="categories-list">
        <button
          :class="['category-item', { 'is-active': filtroProdutoSelecionado === null }]"
          @click="filterByFiltroProduto(null)"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-network"><rect x="16" y="16" width="6" height="6" rx="1"></rect><rect x="2" y="16" width="6" height="6" rx="1"></rect><rect x="9" y="2" width="6" height="6" rx="1"></rect><path d="M5 16v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3"></path><path d="M12 12V8"></path></svg>
          <span>Todos</span>
        </button>

        <button
          v-for="(filtro, k) in filtrosList"
          :key="'filtro-' + k"
          :class="['category-item', { 'is-active': filtroProdutoSelecionado === filtro.id }]"
          @click="filterByFiltroProduto(filtro)"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-list-filter"><path d="M3 6h18" /><path d="M7 12h10" /><path d="M10 18h4" /></svg>
          <span>{{ filtro.nome }}</span>
        </button>
      </div>
    </aside>

    <aside
      class="categories-sidebar mb-4"
      v-if="categoriaSelecionada && subcategorias.length"
    >
      <h3 class="sidebar-title text-center mb-2">Sub Categorias</h3>
      <div class="categories-list">
        <button
          :class="['category-item', { 'is-active': subcategoriaSelecionada === null }]"
          @click="filterBySubcategoria(null)"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-layout-grid"><rect x="3" y="3" width="7" height="7" rx="1" /><rect x="14" y="3" width="7" height="7" rx="1" /><rect x="14" y="14" width="7" height="7" rx="1" /><rect x="3" y="14" width="7" height="7" rx="1" /></svg>
          <span>Todas</span>
        </button>

        <button
          v-for="(subcat, j) in subcategorias"
          :key="'sub-' + j"
          :class="['category-item', { 'is-active': subcategoriaSelecionada === subcat.id }]"
          @click="filterBySubcategoria(subcat)"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-tag"><path d="M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2 2 0 0 0 2.828 0l7.172-7.172a2 2 0 0 0 0-2.828l-8.704-8.704Z" /><line x1="7" x2="7.01" y1="7" y2="7" /></svg>
          <span>{{ subcat.nome }}</span>
        </button>
      </div>
    </aside>

    <aside class="categories-sidebar mb-4">
      <h3 class="sidebar-title text-center mb-2">Categorias</h3>
      <div class="categories-list">
        <button
          :class="['category-item', { 'is-active': categoriaSelecionada === null }]"
          @click="filterByCategoria(null)"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-layers"><polygon points="12 2 2 7 12 12 22 7 12 2"></polygon><polyline points="2 17 12 22 22 17"></polyline><polyline points="2 12 12 17 22 12"></polyline></svg>
          <span>Todas as categorias</span>
        </button>
        <button
          v-for="(categoria, i) in categoriasOrdenadas"
          :key="'cat-' + i"
          :class="['category-item', { 'is-active': categoriaSelecionada === categoria.id }]"
          @click="filterByCategoria(categoria)"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-network"><rect x="16" y="16" width="6" height="6" rx="1"></rect><rect x="2" y="16" width="6" height="6" rx="1"></rect><rect x="9" y="2" width="6" height="6" rx="1"></rect><path d="M5 16v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3"></path><path d="M12 12V8"></path></svg>
          <span>{{ categoria.nome }}</span>
        </button>
      </div>
    </aside>
  </span>
</template>

<script>
import { apiCache } from "@/utils/apiCache";

export default {
  data() {
    return {
      categorias: [],
      categoriaSelecionada: null,
      subcategorias: [],
      subcategoriaSelecionada: null,
      filtrosList: [],
      filtroProdutoSelecionado: null,
      isInternalNavigation: false,
    };
  },

  async mounted() {
    await this.initializeFromQuery();
  },

  methods: {
    async initializeFromQuery() {
      const q = this.$route.query;
      this.categoriaSelecionada = q.categoria || null;
      this.subcategoriaSelecionada = q.subcategoria || null;
      this.filtroProdutoSelecionado = q.filtroproduto || null;

      if (this.categoriaSelecionada) await this.loadSubcategoriasAsync();
      if (this.subcategoriaSelecionada) await this.loadFiltrosListAsync();

      if (this.categorias.length === 0) {
        const res = await apiCache.fetch('categorias', () => this.$api.getCategorias(), {}, 10 * 60 * 1000);
        this.categorias = res.data;
      }
    },

    async loadSubcategoriasAsync() {
      if (!this.categoriaSelecionada) {
        this.subcategorias = [];
        return;
      }
      try {
        // $api.host já resolve para o Gerenciador (com fallback automático
        // para localhost em dev) - não existe mais o antigo endpoint
        // dados_proxy.php do Railway, então usamos sempre dados_api.php.
        const url = `${this.$api.host}/api/dados_api.php`;
        const res = await apiCache.fetch('dados_api_all', () => this.$api.httpService().get(url), {}, 5 * 60 * 1000);
        const structure = res.data.categoryStructure || {};
        const categoryData = structure[this.categoriaSelecionada] || {};
        const subcatsObj = categoryData.subcategories || {};
        const subcats = Object.keys(subcatsObj);
        this.subcategorias = subcats.map(s => ({ id: s, nome: s }));
      } catch (error) {
        console.error("Erro ao carregar subcategorias:", error);
      }
    },

    async loadFiltrosListAsync() {
      if (!this.subcategoriaSelecionada || !this.categoriaSelecionada) {
        this.filtrosList = [];
        return;
      }
      try {
        // Mesma observação: $api.host já resolve para o Gerenciador.
        const url = `${this.$api.host}/api/dados_api.php`;
        const res = await apiCache.fetch('dados_api_all', () => this.$api.httpService().get(url), {}, 5 * 60 * 1000);
        const structure = res.data.categoryStructure || {};
        const categoryData = structure[this.categoriaSelecionada] || {};
        const subcatsObj = categoryData.subcategories || {};
        const subcatData = subcatsObj[this.subcategoriaSelecionada] || {};
        const filters = subcatData.filters || [];
        this.filtrosList = filters.map(f => ({ id: f, nome: f }));
      } catch (error) {
        console.error("Erro ao carregar lista de filtros:", error);
      }
    },

    filterByCategoria(categoria) {
      this.isInternalNavigation = true;
      const catId = categoria ? categoria.id : null;
      if (this.categoriaSelecionada === catId) return;
      
      this.categoriaSelecionada = catId;
      this.subcategoriaSelecionada = null;
      this.filtroProdutoSelecionado = null;
      this.subcategorias = [];
      this.filtrosList = [];
      
      const query = {};
      if (this.categoriaSelecionada) query.categoria = this.categoriaSelecionada;
      this.$router.push({ name: 'products', query }).catch(() => {});
      if (this.categoriaSelecionada) this.loadSubcategoriasAsync();
    },

    filterBySubcategoria(subcategoria) {
      this.isInternalNavigation = true;
      const subcatId = subcategoria ? subcategoria.id : null;
      if (this.subcategoriaSelecionada === subcatId) return;
      
      this.subcategoriaSelecionada = subcatId;
      this.filtroProdutoSelecionado = null;
      this.filtrosList = [];
      
      const query = { categoria: this.categoriaSelecionada };
      if (this.subcategoriaSelecionada) query.subcategoria = this.subcategoriaSelecionada;
      this.$router.push({ name: 'products', query }).catch(() => {});
      if (this.subcategoriaSelecionada) this.loadFiltrosListAsync();
    },

    filterByFiltroProduto(filtro) {
      this.isInternalNavigation = true;
      const filtroId = filtro ? filtro.id : null;
      if (this.filtroProdutoSelecionado === filtroId) return;
      
      this.filtroProdutoSelecionado = filtroId;
      const query = { 
        categoria: this.categoriaSelecionada, 
        subcategoria: this.subcategoriaSelecionada 
      };
      if (this.filtroProdutoSelecionado) query.filtroproduto = this.filtroProdutoSelecionado;
      this.$router.push({ name: 'products', query }).catch(() => {});
    },
  },

  watch: {
    $route(to, from) {
      if (!this.isInternalNavigation && (
          to.query.categoria !== from.query.categoria ||
          to.query.subcategoria !== from.query.subcategoria ||
          to.query.filtroproduto !== from.query.filtroproduto)) {
        this.initializeFromQuery();
      }
      this.isInternalNavigation = false;
    },
  },

  computed: {
    categoriasOrdenadas() {
      let categoriasLista = this.categorias;
      let listaOrdenada = [];
      let ordem = [
        "OLT", "Equipamento de CGNAT", "Roteadores", "Switch", "Placas de equipamentos",
        "Rádios outdoor", "Pontos de acesso", "Transceiver Óptico", "Cabos AOC",
        "Cabos MPO", "Cordões ópticos", "Conversores de mídia", "Conectores e acopladores",
        "Fonte retificadora", "Fonte de alimentação", "ONT", "Acessórios",
      ];
      for (const item of ordem) {
        let cat = categoriasLista.find((c) => c && c.nome === item);
        if (cat) listaOrdenada.push(cat);
      }
      return listaOrdenada;
    },
  },
};
</script>
